<template>
  <section
    class="box-border relative block w-full py-6 leading-10 text-center text-indigo-900 bg-white md:py-8"
  >
    <div
      class="w-full px-4 mx-auto leading-10 text-center md:px-4 lg:px-6 max-w-7xl"
    >
      <div
        class="box-border flex flex-col flex-wrap items-center justify-between text-indigo-900 md:flex-row"
      >
        <div
          class="relative z-10 flex items-center w-auto px-4 leading-10 lg:flex-grow-0 lg:flex-shrink-0 lg:text-left"
        >
          <a
            href="/"
            class="box-border inline-block font-sans text-2xl font-bold text-left text-indigo-900 no-underline bg-transparent cursor-pointer focus:no-underline"
          >
            <img src="../assets/img/logo.svg" alt="" />
          </a>
        </div>
        <div
          class="relative left-0 z-0 flex justify-center w-full px-4 mt-4 space-x-6 font-medium leading-10 md:mt-0 md:absolute lg:space-x-8 md:flex-grow-0 md:text-left lg:text-center"
        >
          <router-link to="/">
            <a
              class="box-border inline-block text-center text-indigo-900 no-underline bg-transparent cursor-pointer hover:text-blue-700 focus:no-underline"
            >
              Home
            </a>
          </router-link>
          <router-link to="/work">
            <a
              class="box-border inline-block text-center text-indigo-900 no-underline bg-transparent cursor-pointer hover:text-blue-700 focus:no-underline"
            >
              Our Work
            </a>
          </router-link>
          <router-link to="/blog">
            <a
              class="box-border inline-block text-center text-indigo-900 no-underline bg-transparent cursor-pointer hover:text-blue-700 focus:no-underline"
            >
              Blog
            </a>
          </router-link>
          <router-link to="/about">
            <a
              class="box-border inline-block text-center text-indigo-900 no-underline bg-transparent cursor-pointer hover:text-blue-700 focus:no-underline"
            >
              About
            </a>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped></style>
